module.exports = __webpack_public_path__ + "static/media/Ooze.928465d6.png";